import { UAParser } from 'ua-parser-js';

export function generateReturnUrl() {
  const currentURL = new URL(window.location.href);
  // Need to be careful with the return URL, can get into a redirect loop if this hits on `/login`
  if (currentURL.pathname === '/login') {
    return '';
  }
  return encodeURIComponent(currentURL.toString());
}

export function getBrowserFromUserAgent() {
  const { browser } = UAParser(navigator.userAgent);
  return browser;
}
